class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    // Volver con el botón "atrás" del navegador desde /checkout restaura la
    // página desde bfcache: ningún script vuelve a correr, así que el
    // IntersectionObserver de arriba (que ya se disparó y desconectó en la
    // carga original) nunca refresca el número del carrito, aunque el
    // "Comprar ahora" sí alcanzó a agregar el producto antes de navegar.
    // 'pageshow' con persisted=true es la única señal de que la página
    // volvió así, y es el único momento en que hace falta forzar este
    // refresco fuera del flujo normal de add/change.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) this.refreshSections();
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.refreshSections().then(() => {
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
    });
  }

  refreshSections() {
    // data-url pide varias secciones (mini-cart, cart-icon-bubble,
    // mobile-cart-icon-bubble) para que esta carga también deje el número
    // del header al día. Antes solo pedía 'mini-cart': el drawer quedaba
    // correcto pero el badge del carrito se quedaba con el valor con el
    // que se sirvió la página, sin forma de corregirse hasta el siguiente
    // /cart/add.js o /cart/change.js real.
    return fetch(this.dataset.url)
      .then(response => response.json())
      .then(sections => {
        this.getSectionsToRender().forEach((section) => {
          const html = sections[section.section];
          if (html && document.getElementById(section.id)) {
            document.getElementById(section.id).innerHTML =
              this.getSectionInnerHTML(html, section.selector);
          }
        });
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
